import * as Yup from "yup";
const VALIDATE_MESSAGE = {
  required: "Thông tin bắt buộc"
};

export const ValidateSchema = Yup.object().shape({
  nam: Yup.number()
    .nullable()
    .required(VALIDATE_MESSAGE.required)
});
